import React from 'react'
import AboutPage from '../components/AboutPage'

function About() {
    return (
        <div>
            <AboutPage/>
        </div>
    )
}

export default About
